import React, { useState, useEffect, useContext } from 'react';
import { RadioProps } from '../../../../api';
import Flag from 'react-flags';
import BeatLoader from "react-spinners/BeatLoader";
import RadioConfigContext from '../../../../context/RadioConfigContext/RadioConfigContext';
import { SingleRadioBox, RadioInnerBackground, SingleInner, RadioName, LoadingBox, HoverPlayButton, HeartButton, FlagBox } from './SingleRadio.css';
import { storageKey } from '../../../../App';
import ReportRadio from './components/ReportRadio/ReportRadio';

/*
  id: number;
  radio_id: string | number;
  name: string;
  thumb: string;
  radio_url: string;
  categories: string;
  streams: string[];
  more: MoreProps;
  radio_group: string;
  type: string;
  radio_img: string;
  radio_img_thumb: string;
*/

const SingleRadio = (props: RadioProps & { showFavs: boolean, changeFavs: () => void }): JSX.Element => {
  const { id, name, thumb, streams } = props;
  const { radioConfig, setRadioConfig } = useContext(RadioConfigContext);
  const [isFav, setIsFav] = useState(false);

  const handlePlayRadio = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('playRadio[#]' + streams[0]);
      setRadioConfig({...radioConfig, streams, url: streams[0], name, thumb, loading: true});
    }
  };

  const handleToggleHeart = () => {
    const storage = (window.localStorage.getItem(storageKey) ? window.localStorage.getItem(storageKey) : '[]') as string;
    const favs = JSON.parse(storage) as RadioProps[];
    const find = favs.findIndex( x => x.id === props.id);
    if (find > -1) {
      favs.splice(find, 1);
      setIsFav(false);
    } else {
      favs.push(props);
      setIsFav(true);
    }
    window.localStorage.setItem(storageKey, JSON.stringify(favs));
    setTimeout(() => {
      props.changeFavs();
    }, 200)
  };

  useEffect(() => {
    const isF = checkIsFav();
    setIsFav(isF);
  }, [props.showFavs]);

  const checkIsFav = () => {
    const storage = (window.localStorage.getItem(storageKey) ? window.localStorage.getItem(storageKey) : '[]') as string;
    const favs = JSON.parse(storage) as RadioProps[];
    const find = favs.findIndex(x => x.id === props.id);
    if (find > -1) {
      return true;
    }
    return false;
  }

  return (
    <SingleRadioBox title={name}>
      <SingleInner>
        <LoadingBox>
          <BeatLoader color="#999" size={10} loading={true} />
        </LoadingBox>
        <RadioInnerBackground bg={thumb} onClick={handlePlayRadio}>
          <HoverPlayButton>
            <i className="fa fa-play-circle" />
          </HoverPlayButton>
        </RadioInnerBackground>
        <RadioName onClick={handlePlayRadio}>{name}</RadioName>
        <HeartButton isFav={isFav} showFavs={props.showFavs} onClick={() => handleToggleHeart()}>
          <i className="fa fa-heart" />
        </HeartButton>
        <ReportRadio id={id} />
        {props.showFavs && <FlagBox>
          <Flag
            basePath="images"
            name={props.country_code}
            format="png"
            pngSize={24}
            shiny={true}
            alt=""
          />
        </FlagBox>}
      </SingleInner>
    </SingleRadioBox>
  );
};

export default SingleRadio;